module.exports = __webpack_public_path__ + "img/9791165508203.5e81e16e.jpg";